
import apiWorker from '../apiWorker'

const template_docs_sent_events = {
    find : (contact, template_doc_sent) => apiWorker('get', `/api/v1/core/template_docs_sent_events/${contact}/${template_doc_sent}`),
}

export default template_docs_sent_events;